export default "__VITE_ASSET__4wZmOfFF__"